<template>
  <div class="itemrepertorio">
    <router-link :to="'repertorio/' + rpt.codigo">
      <div class="repertorio-item" v-bind:class="{ gray: !rpt.cantado }">
        <b style="font-size: 1.1em">{{ rpt.nome }}</b><br />
        {{ rpt.artista }}<br />
        Arranjo por {{ rpt.arranjador }}
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ItemRepertorio',
  props: {
    rpt: Object
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}
.repertorio-item {
  color: white;
  padding: 10px;
  margin-top: 10px;
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
  border-radius:6px;
  -moz-border-radius:6px;
  -webkit-border-radius:6px;
}

.gray {
  background: rgb(64, 64, 64);
  background: linear-gradient(0deg, rgb(64, 64, 64) 0%, rgb(100, 100, 100) 100%);
}

.blue {
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
}
</style>
